module.exports = __webpack_public_path__ + "media/images/flags/germany-98d3eb59ec01b0d895b25ab06613bd5d.jpg";